import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

const get = (path, params) => api.get(path, { params }).then((r) => r.data);

export const fetchConfig = () => get("/config");
export const fetchGames = () => get("/games");
export const fetchPicks = (params) => get("/picks", params);
export const fetchPick = (id) => get(`/picks/${id}`);
export const fetchStats = (params) => get("/results/stats", params);
export const fetchLedger = (params) => get("/results/ledger", params);
export const fetchChart = (params) => get("/results/chart", params);
export const fetchAnalytics = (params) => get("/results/analytics", params);
export const fetchSeasons = () => get("/results/seasons");
export const fetchHistorical = (params) => get("/results/historical", params);
export const fetchReviews = () => get("/reviews");
export const fetchMemberMe = () => get("/auth/whop/me");
export const memberLogout = () => api.post("/auth/whop/logout").then((r) => r.data);
export const updateMemberPreferences = (prefs) => api.put("/auth/whop/preferences", prefs).then((r) => r.data);
export const WHOP_LOGIN_URL = `${API}/auth/whop/start`;
export const fetchDashboardSummary = () => get("/dashboard/summary");
export const fetchFeaturedFree = () => get("/picks/featured-free");
export const fetchPropStats = (id) => get(`/picks/${id}/prop-stats`);

export const fmtUnits = (v) => `${v > 0 ? "+" : ""}${Number(v).toFixed(2).replace(/\.?0+$/, (m) => (m.includes(".") ? "" : m))}U`.replace("U", "U");
export const fmtSigned = (v, suffix = "") => `${v > 0 ? "+" : ""}${v}${suffix}`;

export const MARKET_LABELS = {
  player_prop: "Player Prop",
  spread: "Spread",
  moneyline: "Moneyline",
  total: "Total",
  multi: "Multi",
  other: "Other",
};
